// import React, { useEffect, useState, useRef } from 'react'; // Added useRef
// import {
//     Box,
//     Button,
//     Typography,
//     IconButton,
//     Grid,
//     CircularProgress,
//     Modal,
//     ImageList,
//     ImageListItem,
//     ImageListItemBar,
//     Fade,
//     Backdrop,
// } from '@mui/material';
// import { CloudUpload, Delete, Close, Edit } from '@mui/icons-material'; // Added Edit icon
// import axios from 'axios';
// import { v4 as uuidv4 } from 'uuid';
// // --- Assuming you have these helper functions ---
// import { generatePreSignedUrl, deleteImage } from 'helpers/Content_helper';
// import { addImages, deleteImageFromS3 } from 'helpers/batch_helper';
// import { toast } from 'react-toastify';

// // Styles for the Modal
// const modalStyle = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     bgcolor: 'background.paper',
//     boxShadow: 24,
//     p: 1,
//     outline: 'none',
//     maxWidth: '90vw',
//     maxHeight: '90vh',
// };

// const ImageUploader = ({ batchId, trainingImages = [], fetchBatchDetails }) => {
//     const [images, setImages] = useState([]);
//     const [loading, setLoading] = useState(false);

//     // State for the full-screen image modal
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedImage, setSelectedImage] = useState(null);

//     // --- NEW: Ref and state for the update functionality ---
//     const updateFileRef = useRef(null);
//     const [updatingImageName, setUpdatingImageName] = useState(null);

//     const handleFileChange = (event) => {
//         const files = Array.from(event.target.files);
//         setImages(prev => [...prev, ...files]);
//     };

//     const handleRemoveImage = (index) => {
//         setImages(prev => prev.filter((_, i) => i !== index));
//     };

//     const handleOpenModal = (imageUrl) => {
//         setSelectedImage(imageUrl);
//         setIsModalOpen(true);
//     };

//     const handleCloseModal = () => {
//         setIsModalOpen(false);
//         setSelectedImage(null);
//     };

//     // --- NEW: Starts the image update process ---
//     const handleUpdateClick = (imageName) => {
//         setUpdatingImageName(imageName); // Store the name of the image to update
//         updateFileRef.current.click();    // Programmatically click the hidden file input
//     };

//     // --- NEW: Handles the file selection and executes the update logic ---
//     const handleFileSelectForUpdate = async (event) => {
//         const file = event.target.files[0];
//         if (!file || !updatingImageName) {
//             setUpdatingImageName(null);
//             return;
//         }

//         setLoading(true);
//         try {
//             // Step 1: Delete the old image from S3.
//             const deleteResult = await deleteImageFromS3(updatingImageName);
//             if (!deleteResult?.success) {
//                 throw new Error('Failed to delete the old image.');
//             }

//             // Step 2: Generate a pre-signed URL with the SAME name.
//             const presignResult = await generatePreSignedUrl({ name: updatingImageName, type: "image" });
//             if (!presignResult?.success) {
//                 throw new Error('Failed to generate an upload URL.');
//             }

//             // Step 3: Upload the new file to the pre-signed URL.
//             await axios.put(presignResult.presignedUrl, file, {
//                 headers: { 'Content-Type': file.type },
//             });

//             toast.success(`Image "${updatingImageName}" updated successfully!`);
//             fetchBatchDetails(); // Refresh the component to show the new image

//         } catch (err) {
//             console.error(`Failed to update image ${updatingImageName}`, err);
//             toast.error(err.message || 'Failed to update image. Please try again.');
//             // Refresh details anyway to ensure UI reflects the actual server state
//             fetchBatchDetails();
//         } finally {
//             setLoading(false);
//             setUpdatingImageName(null); // Reset the state
//             if (updateFileRef.current) {
//                 updateFileRef.current.value = null; // Reset input to allow re-selecting the same file
//             }
//         }
//     };

//     const handleUpload = async () => {
//         // ... (This function remains unchanged)
//         setLoading(true);
//         const uploadedImageNames = [];

//         for (const file of images) {
//             const name = uuidv4() + '.' + file.name.split('.').pop();
//             const result = await generatePreSignedUrl({ name, type: "image" });

//             if (result?.success) {
//                 const url = result.presignedUrl;
//                 try {
//                     await axios.put(url, file, {
//                         headers: { 'Content-Type': file.type },
//                     });
//                     uploadedImageNames.push(name);
//                 } catch (err) {
//                     toast.error(`Failed to upload ${file.name}.`);
//                     console.error(`Failed to upload ${name}`, err);
//                 }
//             }
//         }

//         if (uploadedImageNames.length > 0) {
//             try {
//                 const data = await addImages({ id: batchId, images: uploadedImageNames });
//                 if (data?.success) {
//                     toast.success(data?.message);
//                     setImages([]);
//                     fetchBatchDetails();
//                 } else {
//                     toast.error(data?.message);
//                 }
//             } catch (err) {
//                 console.error('Error saving image URLs:', err);
//                 toast.error('Failed to save image URLs.');
//             }
//         }

//         setLoading(false);
//     };

//     // --- MODIFIED: Extract image name from URL for update/delete operations ---
//     const existingImages = trainingImages.map(url => ({
//         url,
//         name: url.substring(url.lastIndexOf('/') + 1).split('?')[0], // Extract filename from URL
//         isPreview: false,
//     }));
//     const previewImages = images.map(file => ({ url: URL.createObjectURL(file), isPreview: true, file }));

//     const allImagesToDisplay = [...existingImages, ...previewImages];

//     return (
//         <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 800, margin: 'auto' }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Typography variant="h5">Upload Images</Typography>
//                 <Button variant="contained" component="label" startIcon={<CloudUpload />}>
//                     Select Images
//                     <input type="file" hidden accept="image/*" multiple onChange={handleFileChange} />
//                 </Button>
//                 {/* --- NEW: Hidden file input for the update action --- */}
//                 <input type="file" hidden ref={updateFileRef} accept="image/*" onChange={handleFileSelectForUpdate} />
//             </Box>

//             {allImagesToDisplay.length > 0 ? (
//                 <ImageList variant="masonry" cols={3} gap={8}>
//                     {allImagesToDisplay.map((img) => (
//                         <ImageListItem key={img.url} sx={{ borderRadius: 1, overflow: 'hidden' }}>
//                             <img
//                                 src={img.url}
//                                 alt={img.name || 'upload-preview'}
//                                 loading="lazy"
//                                 style={{ cursor: 'pointer', display: 'block', width: '100%' }}
//                                 onClick={() => handleOpenModal(img.url)}
//                             />
//                             {/* --- MODIFIED: Conditionally render Delete or Edit icon --- */}
//                             <ImageListItemBar
//                                 sx={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)' }}
//                                 position="top"
//                                 actionPosition="right"
//                                 actionIcon={
//                                     img.isPreview ? (
//                                         // Show Delete icon for new, un-uploaded images
//                                         <IconButton sx={{ color: 'white' }} onClick={() => handleRemoveImage(images.indexOf(img.file))}>
//                                             <Delete />
//                                         </IconButton>
//                                     ) : (
//                                         // Show Edit icon for existing, uploaded images
//                                         <IconButton sx={{ color: 'white' }} onClick={() => handleUpdateClick(img.name)}>
//                                             <Edit />
//                                         </IconButton>
//                                     )
//                                 }
//                             />
//                         </ImageListItem>
//                     ))}
//                 </ImageList>
//             ) : (
//                 <Box sx={{ textAlign: 'center', p: 5, border: '2px dashed grey', borderRadius: 2 }}>
//                     <Typography color="text.secondary">No images selected for upload.</Typography>
//                     <Typography variant="body2" color="text.secondary">Use the button above to select images.</Typography>
//                 </Box>
//             )}

//             <Box mt={3}>
//                 <Button
//                     variant="contained"
//                     color="primary"
//                     disabled={images.length === 0 || loading}
//                     onClick={handleUpload}
//                     sx={{ minWidth: 100 }}
//                 >
//                     {loading ? <CircularProgress size={24} color="inherit" /> : 'Submit'}
//                 </Button>
//             </Box>

//             <Modal open={isModalOpen} onClose={handleCloseModal} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 500 }}>
//                 <Fade in={isModalOpen}>
//                     <Box sx={modalStyle}>
//                         <IconButton
//                             aria-label="close"
//                             onClick={handleCloseModal}
//                             sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1, color: 'white', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
//                         >
//                             <Close />
//                         </IconButton>
//                         <img
//                             src={selectedImage}
//                             alt="Full screen view"
//                             style={{ width: '100%', height: 'auto', maxHeight: '90vh', objectFit: 'contain' }}
//                         />
//                     </Box>
//                 </Fade>
//             </Modal>
//         </Box>
//     );
// };

// export default ImageUploader;








import React, { useEffect, useState, useRef } from 'react';
import {
    Box,
    Button,
    Typography,
    IconButton,
    Grid,
    CircularProgress,
    Modal,
    Fade,
    Backdrop,
    Paper,
    Card,
    CardContent,
    Chip,
    Alert,
    Stack,
    ImageList,
    ImageListItem,
    ImageListItemBar,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import CloudUpload from '@mui/icons-material/CloudUpload';
import Delete from '@mui/icons-material/Delete';
import Close from '@mui/icons-material/Close';
import CheckCircle from '@mui/icons-material/CheckCircle';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import Refresh from '@mui/icons-material/Refresh';
import Edit from '@mui/icons-material/Edit';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { generatePreSignedUrl } from 'helpers/Content_helper';
import { addImages, deleteImageFromS3 } from 'helpers/batch_helper';
import { toast } from 'react-toastify';

// Define the 4 required image types
const IMAGE_TYPES = [
    {
        id: 'classroom_front',
        label: 'Classroom Image',
        description: 'classroom image with Trainer & Students(Selfie image of  Classroom)',
        required: true,
        color: '#1976d2',
        icon: '🏫',
    },
    {
        id: 'classroom_back',
        label: 'Attendance Sheet Image',
        description: 'Training Attendance Sheet with student Name',
        required: true,
        color: '#2e7d32',
        icon: '👨‍🎓',
    },
    {
        id: 'practical',
        label: 'Practical Session',
        description: 'Hands-on practical training',
        required: true,
        color: '#ed6c02',
        icon: '🔧',
    },
    {
        id: 'group',
        label: 'Group Photo',
        description: 'Group photo with everyone',
        required: true,
        color: '#9c27b0',
        icon: '👥',
    },
];

// Modal style
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    outline: 'none',
    maxWidth: '90vw',
    maxHeight: '90vh',
    borderRadius: 2,
};

// Helper function to extract filename from URL
const extractFilenameFromUrl = (url) => {
    if (!url) return null;
    const urlParts = url.split('/');
    return urlParts[urlParts.length - 1].split('?')[0];
};

// Helper function to generate S3 URL
const generateS3Url = (filename) => {
    if (!filename) return null;
    const bucketName = 'amasslms';
    const region = 'ap-south-1';
    return `https://${bucketName}.s3.${region}.amazonaws.com/${filename}`;
};

// Helper function to generate a shorter filename (max 100 chars)
const generateShortFilename = (batchId, type, extension) => {
    // Create a shorter UUID (first 8 chars)
    const shortUuid = uuidv4().split('-')[0];
    
    // Shorten batchId if it's too long (max 30 chars)
    const shortBatchId = batchId.length > 30 ? batchId.substring(0, 30) : batchId;
    
    // Create filename: batch_type_shortuuid.ext
    const filename = `${shortBatchId}_${type}_${shortUuid}.${extension}`;
    
    // Ensure filename doesn't exceed 100 characters (safe for most databases)
    return filename.length > 100 ? filename.substring(0, 100) : filename;
};

const ImageUploader = ({ batchId, trainingImages = [], fetchBatchDetails }) => {
    // State management
    const [uploadedImages, setUploadedImages] = useState({});
    const [pendingImages, setPendingImages] = useState({});
    const [loading, setLoading] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
    const [updatingType, setUpdatingType] = useState(null);
    const [updateFile, setUpdateFile] = useState(null);
    const [updatePreview, setUpdatePreview] = useState(null);
    const [networkError, setNetworkError] = useState(false);
    
    // Refs
    const fileInputRefs = useRef({});
    const updateFileInputRef = useRef(null);

    // Initialize state from props
    useEffect(() => {
        console.log('Initializing images for batch:', batchId);
        
        const uploaded = {};
        const pending = {};
        
        // Initialize all types as null
        IMAGE_TYPES.forEach(type => {
            uploaded[type.id] = null;
            pending[type.id] = null;
        });
        
        // Process trainingImages if available
        if (Array.isArray(trainingImages) && trainingImages.length > 0) {
            trainingImages.forEach((item, index) => {
                if (!item) return;
                
                let url, name, type;
                
                if (typeof item === 'string') {
                    // Simple URL string
                    url = item;
                    name = extractFilenameFromUrl(item);
                    type = IMAGE_TYPES[index]?.id;
                } else if (typeof item === 'object') {
                    // Object with properties
                    url = item.url || item.imageUrl || item.src;
                    name = item.name || extractFilenameFromUrl(url);
                    type = item.type || item.section || item.imageType || IMAGE_TYPES[index]?.id;
                }
                
                if (url && type) {
                    uploaded[type] = {
                        url,
                        name,
                        type,
                        typeLabel: IMAGE_TYPES.find(t => t.id === type)?.label || type,
                        isUploaded: true,
                        uploadedAt: new Date().toISOString(),
                    };
                }
            });
        }
        
        console.log('Uploaded images initialized:', uploaded);
        setUploadedImages(uploaded);
        setPendingImages(pending);
        setNetworkError(false);
    }, [trainingImages, batchId]);

    // Helper functions
    const isComplete = () => {
        return IMAGE_TYPES.every(type => uploadedImages[type.id] !== null);
    };

    const hasPendingUploads = () => {
        return IMAGE_TYPES.some(type => pendingImages[type.id] !== null);
    };

    const getCompletionStatus = () => {
        const uploadedCount = Object.values(uploadedImages).filter(img => img !== null).length;
        return {
            uploaded: uploadedCount,
            total: IMAGE_TYPES.length,
            percentage: (uploadedCount / IMAGE_TYPES.length) * 100,
        };
    };

    // File handling
    const handleFileSelect = (typeId, event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            toast.error('Please select an image file (JPEG, PNG, etc.)');
            return;
        }

        if (file.size > 3 * 1024 * 1024) {
            toast.error('Image size should be less than 3MB for better performance');
            return;
        }

        if (uploadedImages[typeId]) {
            toast.warning('This section already has an uploaded image. Update it instead.');
            return;
        }

        const type = IMAGE_TYPES.find(t => t.id === typeId);
        const previewUrl = URL.createObjectURL(file);
        
        setPendingImages(prev => ({
            ...prev,
            [typeId]: {
                file,
                previewUrl,
                originalName: file.name,
                type: typeId,
                typeLabel: type.label,
                size: file.size,
                mimeType: file.type,
                selectedAt: new Date().toISOString(),
            }
        }));
        
        toast.success(`${type.label} image selected`);
    };

    const handleRemovePendingImage = (typeId) => {
        const pendingImage = pendingImages[typeId];
        if (pendingImage?.previewUrl) {
            URL.revokeObjectURL(pendingImage.previewUrl);
        }
        
        setPendingImages(prev => ({
            ...prev,
            [typeId]: null
        }));
        toast.info('Image removed from selection');
    };

    const handleRemoveUploadedImage = async (typeId) => {
        const image = uploadedImages[typeId];
        if (!image) return;

        if (!window.confirm(`Are you sure you want to delete the ${image.typeLabel} image?`)) {
            return;
        }

        setLoading(true);
        try {
            const deleteResult = await deleteImageFromS3(image.name);
            if (deleteResult?.success) {
                toast.success('Image deleted successfully');
                
                setUploadedImages(prev => ({
                    ...prev,
                    [typeId]: null
                }));
                
                fetchBatchDetails();
            } else {
                toast.error('Failed to delete image');
            }
        } catch (error) {
            console.error('Delete error:', error);
            toast.error('Failed to delete image');
        } finally {
            setLoading(false);
        }
    };

    // Upload functions with shorter filenames
    const getPresignedUrlWithRetry = async (fileName) => {
        try {
            console.log('Getting pre-signed URL for:', fileName);
            const result = await generatePreSignedUrl({
                name: fileName,
                type: "image"
            });
            
            if (!result?.success || !result.presignedUrl) {
                throw new Error('Failed to get upload URL');
            }
            
            return result;
        } catch (error) {
            console.error('Error getting presigned URL:', error);
            throw new Error('Network error. Please check your connection.');
        }
    };

    const uploadToS3 = async (file, presignedUrl) => {
        try {
            console.log('Uploading to S3...');
            
            // Use fetch API for better binary upload
            const response = await fetch(presignedUrl, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type || 'application/octet-stream',
                },
            });
            
            if (!response.ok) {
                throw new Error(`S3 upload failed: ${response.status}`);
            }
            
            console.log('S3 upload successful');
            return { success: true };
        } catch (error) {
            console.error('S3 upload error:', error);
            throw new Error('Upload failed. Please check your internet connection.');
        }
    };

    const saveImageToDatabase = async (fileName, type) => {
        try {
            console.log('Saving to database:', { fileName, type, batchId });
            
            const result = await addImages({
                id: batchId,
                images: [fileName],
            });
            
            if (result?.success) {
                return result;
            } else {
                throw new Error(result?.message || 'Failed to save image record');
            }
        } catch (error) {
            console.error('Database save error:', error);
            
            // Check for specific database errors
            if (error.message?.includes('Data too long') || error.message?.includes('Data truncation')) {
                throw new Error('Image name is too long. Please try with a shorter filename.');
            }
            
            throw new Error('Failed to save image to database');
        }
    };

    // Upload single image with shorter filename
    const uploadSingleImage = async (typeId, pendingImage) => {
        try {
            console.log(`Starting upload for ${pendingImage.typeLabel}`);
            
            // 1. Generate shorter filename
            const fileExtension = pendingImage.file.name.split('.').pop().toLowerCase();
            const fileName = generateShortFilename(batchId, typeId, fileExtension);
            console.log('Generated filename:', fileName, 'Length:', fileName.length);
            
            // 2. Get pre-signed URL
            const presignResult = await getPresignedUrlWithRetry(fileName);
            
            // 3. Upload to S3
            await uploadToS3(pendingImage.file, presignResult.presignedUrl);
            
            // 4. Save to database
            await saveImageToDatabase(fileName, typeId);
            
            // 5. Generate viewable URL
            const viewableUrl = generateS3Url(fileName);
            
            console.log(`Upload completed for ${pendingImage.typeLabel}`);
            
            return {
                success: true,
                fileName,
                originalName: pendingImage.originalName,
                url: viewableUrl,
                type: typeId,
                typeLabel: pendingImage.typeLabel,
            };
            
        } catch (error) {
            console.error(`Upload failed for ${pendingImage.typeLabel}:`, error);
            throw error;
        }
    };

    // Main upload function
    const handleUploadAll = async () => {
        if (!hasPendingUploads()) {
            toast.warning('No images selected for upload');
            return;
        }

        if (!batchId) {
            toast.error('Batch ID is required');
            return;
        }

        setUploading(true);
        setNetworkError(false);
        
        const successfulUploads = [];
        const failedUploads = [];
        
        // Get all pending types
        const pendingTypes = IMAGE_TYPES.filter(type => pendingImages[type.id]);
        
        // Upload sequentially
        for (const type of pendingTypes) {
            const pendingImage = pendingImages[type.id];
            
            try {
                console.log(`Processing ${type.label}...`);
                
                const result = await uploadSingleImage(type.id, pendingImage);
                successfulUploads.push({ typeId: type.id, result });
                
                toast.success(`${type.label} uploaded successfully!`);
                
            } catch (error) {
                console.error(`Failed to upload ${type.label}:`, error);
                failedUploads.push({
                    type: type.label,
                    error: error.message
                });
                
                toast.error(`Failed to upload ${type.label}: ${error.message}`);
            }
        }
        
        // Update state based on results
        if (successfulUploads.length > 0) {
            const newUploadedImages = { ...uploadedImages };
            const newPendingImages = { ...pendingImages };
            
            successfulUploads.forEach(({ typeId, result }) => {
                newUploadedImages[typeId] = {
                    url: result.url,
                    name: result.fileName,
                    originalName: result.originalName,
                    type: typeId,
                    typeLabel: result.typeLabel,
                    isUploaded: true,
                    uploadedAt: new Date().toISOString(),
                };
                
                newPendingImages[typeId] = null;
                
                // Clean up preview URL
                const pendingImage = pendingImages[typeId];
                if (pendingImage?.previewUrl) {
                    URL.revokeObjectURL(pendingImage.previewUrl);
                }
            });
            
            setUploadedImages(newUploadedImages);
            setPendingImages(newPendingImages);
        }
        
        // Show final result
        if (failedUploads.length === 0 && successfulUploads.length > 0) {
            toast.success(`All ${successfulUploads.length} images uploaded successfully!`);
            
            // Refresh from server
            setTimeout(() => {
                fetchBatchDetails();
            }, 2000);
            
        } else if (failedUploads.length > 0) {
            const failedTypes = failedUploads.map(f => f.type).join(', ');
            toast.error(`Failed to upload: ${failedTypes}`);
            
            // Offer retry for database errors
            const hasDatabaseError = failedUploads.some(f => 
                f.error.includes('too long') || f.error.includes('Data truncation')
            );
            
            if (hasDatabaseError) {
                toast.info(
                    <div>
                        <p>Database error detected. Please try uploading one image at a time.</p>
                        <Button 
                            size="small" 
                            variant="contained" 
                            onClick={() => {
                                // Clear all pending and suggest individual upload
                                const cleared = {};
                                IMAGE_TYPES.forEach(type => {
                                    cleared[type.id] = null;
                                });
                                setPendingImages(cleared);
                                toast.info('Please try uploading images one by one');
                            }}
                            sx={{ mt: 1 }}
                        >
                            Clear All & Retry Individually
                        </Button>
                    </div>,
                    { autoClose: false }
                );
            }
        }
        
        setUploading(false);
    };

    // Update functions
    const handleOpenUpdateDialog = (typeId) => {
        setUpdatingType(typeId);
        setUpdateDialogOpen(true);
    };

    const handleUpdateFileSelect = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            toast.error('Please select an image file');
            return;
        }

        if (file.size > 3 * 1024 * 1024) {
            toast.error('Image size should be less than 3MB');
            return;
        }

        setUpdateFile(file);
        setUpdatePreview(URL.createObjectURL(file));
    };

    const handleCloseUpdateDialog = () => {
        setUpdateDialogOpen(false);
        setUpdatingType(null);
        setUpdateFile(null);
        if (updatePreview) {
            URL.revokeObjectURL(updatePreview);
            setUpdatePreview(null);
        }
        if (updateFileInputRef.current) {
            updateFileInputRef.current.value = '';
        }
    };

    const handleExecuteUpdate = async () => {
        if (!updatingType || !updateFile) return;

        const oldImage = uploadedImages[updatingType];
        if (!oldImage) {
            toast.error('No image found to update');
            return;
        }

        setLoading(true);
        setUpdateDialogOpen(false);
        
        try {
            // Use the existing filename (no need to generate new one for update)
            const fileName = oldImage.name;
            
            // Get presigned URL
            const presignResult = await getPresignedUrlWithRetry(fileName);
            
            // Upload to S3
            await uploadToS3(updateFile, presignResult.presignedUrl);
            
            // Generate new URL
            const newUrl = generateS3Url(fileName);
            
            // Update state
            setUploadedImages(prev => ({
                ...prev,
                [updatingType]: {
                    ...prev[updatingType],
                    url: newUrl,
                    updatedAt: new Date().toISOString(),
                }
            }));
            
            toast.success('Image updated successfully!');
            
            // Refresh data
            setTimeout(() => {
                fetchBatchDetails();
            }, 1000);
            
        } catch (error) {
            console.error('Update error:', error);
            toast.error(error.message || 'Failed to update image');
        } finally {
            setLoading(false);
            handleCloseUpdateDialog();
        }
    };

    // Refresh function
    const handleRefreshImages = async () => {
        setRefreshing(true);
        try {
            await fetchBatchDetails();
            toast.success('Images refreshed');
        } catch (error) {
            console.error('Error refreshing images:', error);
            toast.error('Failed to refresh images');
        } finally {
            setRefreshing(false);
        }
    };

    // Image preview
    const handleOpenModal = (imageUrl) => {
        if (imageUrl) {
            setSelectedImage(imageUrl);
            setIsModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    // Render image card
    const renderImageCard = (type) => {
        const uploadedImage = uploadedImages[type.id];
        const pendingImage = pendingImages[type.id];
        const hasImage = uploadedImage || pendingImage;
        const isUploaded = !!uploadedImage;
        
        let displayUrl = null;
        if (pendingImage) {
            displayUrl = pendingImage.previewUrl;
        } else if (uploadedImage) {
            displayUrl = uploadedImage.url;
        }

        return (
            <Card 
                key={type.id}
                sx={{ 
                    height: '100%',
                    border: hasImage ? `2px solid ${type.color}` : '2px dashed #e0e0e0',
                    transition: 'all 0.3s',
                    opacity: networkError && !isUploaded ? 0.7 : 1,
                }}
            >
                <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    {/* Card Header */}
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <Box sx={{ fontSize: 24, mr: 2 }}>{type.icon}</Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h6" sx={{ color: type.color }}>
                                {type.label}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {type.description}
                            </Typography>
                        </Box>
                        {hasImage && (
                            <Chip
                                label={isUploaded ? "Uploaded" : "Pending"}
                                color={isUploaded ? "success" : "warning"}
                                size="small"
                                icon={isUploaded ? <CheckCircle /> : <PhotoCamera />}
                            />
                        )}
                    </Box>

                    {/* Image Preview */}
                    <Box 
                        sx={{ 
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: 200,
                            maxHeight: 300,
                            borderRadius: 2,
                            overflow: 'hidden',
                            bgcolor: 'grey.50',
                            border: '1px solid #e0e0e0',
                            mb: 2,
                            position: 'relative',
                            cursor: hasImage && displayUrl ? 'pointer' : 'default',
                        }}
                        onClick={() => {
                            if (displayUrl) {
                                handleOpenModal(displayUrl);
                            }
                        }}
                    >
                        {displayUrl ? (
                            <>
                                <img
                                    src={displayUrl}
                                    alt={type.label}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                    }}
                                    onError={(e) => {
                                        e.target.style.display = 'none';
                                        const box = e.target.parentElement;
                                        box.innerHTML = `
                                            <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100%; padding: 20px;">
                                                <span style="font-size: 48px;">📷</span>
                                                <span style="color: #666; margin-top: 8px; text-align: center;">Image available</span>
                                                <span style="color: #999; font-size: 12px; margin-top: 4px;">Click to view</span>
                                            </div>
                                        `;
                                    }}
                                />
                                {pendingImage && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            bgcolor: 'rgba(0,0,0,0.3)',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexDirection: 'column',
                                        }}
                                    >
                                        <Typography variant="body2" color="white" sx={{ fontWeight: 'bold' }}>
                                            Ready to Upload
                                        </Typography>
                                        <Typography variant="caption" color="white">
                                            {Math.round(pendingImage.size / 1024)} KB
                                        </Typography>
                                    </Box>
                                )}
                            </>
                        ) : (
                            <>
                                <PhotoCamera sx={{ fontSize: 48, color: 'grey.400', mb: 2 }} />
                                <Typography variant="body2" color="text.secondary">
                                    No image selected
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Max 3MB
                                </Typography>
                            </>
                        )}
                    </Box>

                    {/* Action Buttons */}
                    <Box sx={{ display: 'flex', gap: 1, mt: 'auto' }}>
                        {!hasImage ? (
                            <Button
                                fullWidth
                                variant="outlined"
                                component="label"
                                startIcon={<CloudUpload />}
                                sx={{ borderColor: type.color, color: type.color }}
                                disabled={loading || uploading || refreshing || networkError}
                            >
                                Select Image
                                <input
                                    type="file"
                                    hidden
                                    accept="image/*"
                                    onChange={(e) => handleFileSelect(type.id, e)}
                                    ref={el => fileInputRefs.current[type.id] = el}
                                />
                            </Button>
                        ) : pendingImage ? (
                            <>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    component="label"
                                    startIcon={<CloudUpload />}
                                    disabled={uploading || refreshing || loading || networkError}
                                    sx={{ flex: 2 }}
                                >
                                    Change
                                    <input
                                        type="file"
                                        hidden
                                        accept="image/*"
                                        onChange={(e) => handleFileSelect(type.id, e)}
                                    />
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={() => handleRemovePendingImage(type.id)}
                                    disabled={uploading || refreshing || loading}
                                    sx={{ flex: 1 }}
                                >
                                    <Delete />
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    fullWidth
                                    variant="outlined"
                                    startIcon={<Edit />}
                                    onClick={() => handleOpenUpdateDialog(type.id)}
                                    disabled={loading || uploading || refreshing || networkError}
                                    sx={{ flex: 2 }}
                                >
                                    Update
                                </Button>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={() => handleRemoveUploadedImage(type.id)}
                                    disabled={loading || uploading || refreshing}
                                    sx={{ flex: 1 }}
                                >
                                    <Delete />
                                </Button>
                            </>
                        )}
                    </Box>
                </CardContent>
            </Card>
        );
    };

    // Render all images grid
    const renderAllImagesGrid = () => {
        const allImages = [
            ...Object.values(uploadedImages).filter(img => img !== null).map(img => ({ 
                ...img, 
                isPreview: false 
            })),
            ...Object.values(pendingImages).filter(img => img !== null).map(img => ({ 
                url: img.previewUrl, 
                name: img.originalName,
                type: img.type,
                typeLabel: img.typeLabel,
                isPreview: true,
                file: img.file 
            }))
        ];

        if (allImages.length === 0) {
            return (
                <Box sx={{ textAlign: 'center', p: 5, border: '2px dashed #ccc', borderRadius: 2 }}>
                    <PhotoCamera sx={{ fontSize: 64, color: 'grey.400', mb: 2 }} />
                    <Typography color="text.secondary">No images uploaded yet</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Select images using the cards above
                    </Typography>
                </Box>
            );
        }

        return (
            <ImageList variant="masonry" cols={3} gap={8}>
                {allImages.map((img, index) => (
                    <ImageListItem key={`${img.type}-${index}`} sx={{ borderRadius: 1, overflow: 'hidden' }}>
                        <img
                            src={img.url}
                            alt={img.typeLabel}
                            loading="lazy"
                            style={{ cursor: 'pointer', display: 'block', width: '100%' }}
                            onClick={() => handleOpenModal(img.url)}
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = `
                                    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 200px; background: #f5f5f5; border-radius: 8px;">
                                        <span style="font-size: 36px;">📷</span>
                                        <span style="color: #666; margin-top: 8px;">${img.typeLabel}</span>
                                        <span style="color: #999; font-size: 12px; margin-top: 4px;">${img.isPreview ? 'Pending upload' : 'Uploaded'}</span>
                                    </div>
                                `;
                            }}
                        />
                        <ImageListItemBar
                            sx={{ 
                                background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                            }}
                            position="top"
                            actionPosition="right"
                            title={img.typeLabel}
                            subtitle={img.isPreview ? 'Pending upload' : 'Uploaded'}
                            actionIcon={
                                img.isPreview ? (
                                    <IconButton 
                                        sx={{ color: 'white' }} 
                                        onClick={() => handleRemovePendingImage(img.type)}
                                    >
                                        <Delete />
                                    </IconButton>
                                ) : (
                                    <IconButton 
                                        sx={{ color: 'white' }} 
                                        onClick={() => handleOpenUpdateDialog(img.type)}
                                    >
                                        <Edit />
                                    </IconButton>
                                )
                            }
                        />
                    </ImageListItem>
                ))}
            </ImageList>
        );
    };

    const completionStatus = getCompletionStatus();
    const pendingCount = Object.values(pendingImages).filter(img => img !== null).length;

    return (
        <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1200, margin: 'auto' }}>
            {/* Network Error Alert */}
            {networkError && (
                <Alert 
                    severity="error" 
                    sx={{ mb: 3 }}
                    action={
                        <Button 
                            color="inherit" 
                            size="small"
                            onClick={() => {
                                setNetworkError(false);
                                handleRefreshImages();
                            }}
                        >
                            Retry Connection
                        </Button>
                    }
                >
                    Network connection issue detected. Please check your internet connection.
                </Alert>
            )}

            {/* Header */}
            <Paper sx={{ p: 3, mb: 4, borderRadius: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 2 }}>
                    <Box>
                        <Typography variant="h5" gutterBottom>
                            Training Batch Documentation
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Upload exactly 4 images (one for each category)
                        </Typography>
                        {batchId && (
                            <Typography variant="caption" color="text.secondary">
                                Batch ID: {batchId}
                            </Typography>
                        )}
                    </Box>
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Refresh />}
                            onClick={handleRefreshImages}
                            disabled={refreshing || loading || uploading}
                        >
                            {refreshing ? <CircularProgress size={20} /> : 'Refresh'}
                        </Button>
                        
                        <Box sx={{ minWidth: 200, textAlign: 'center' }}>
                            <Typography variant="h6" gutterBottom>
                                {completionStatus.uploaded} / 4 Images
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-flex', width: '100%' }}>
                                <CircularProgress
                                    variant="determinate"
                                    value={completionStatus.percentage}
                                    size={80}
                                    thickness={4}
                                    sx={{ 
                                        color: completionStatus.percentage === 100 ? '#4caf50' : 
                                            completionStatus.percentage >= 50 ? '#ff9800' : '#f44336'
                                    }}
                                />
                                <Box
                                    sx={{
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        position: 'absolute',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Typography variant="h6" component="div" color="text.secondary">
                                        {Math.round(completionStatus.percentage)}%
                                    </Typography>
                                </Box>
                            </Box>
                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                {completionStatus.percentage === 100 
                                    ? 'All images uploaded!'
                                    : `${4 - completionStatus.uploaded} more required`}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>

            {/* Image Cards for each type */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
                {IMAGE_TYPES.map((type) => (
                    <Grid item xs={12} sm={6} key={type.id}>
                        {renderImageCard(type)}
                    </Grid>
                ))}
            </Grid>

            {/* Hidden file input for update */}
            <input 
                type="file" 
                hidden 
                ref={updateFileInputRef} 
                accept="image/*" 
                onChange={handleUpdateFileSelect} 
            />

            {/* All Images Grid View */}
            <Paper sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                <Typography variant="h6" gutterBottom>
                    All Images ({completionStatus.uploaded} uploaded, {pendingCount} pending)
                </Typography>
                {renderAllImagesGrid()}
            </Paper>

            {/* Upload All Button */}
            <Paper sx={{ p: 3, borderRadius: 2, bgcolor: 'grey.50' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
                    <Box>
                        <Typography variant="h6" gutterBottom>
                            Upload Status
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {hasPendingUploads() 
                                ? `${pendingCount} image(s) ready to upload`
                                : isComplete()
                                    ? 'All images have been uploaded'
                                    : 'Select images for upload'
                            }
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Maximum file size: 3MB per image
                        </Typography>
                        {uploading && (
                            <Alert severity="info" sx={{ mt: 1, width: '100%' }}>
                                Uploading images... Please wait.
                            </Alert>
                        )}
                    </Box>
                    
                    <Stack direction="row" spacing={2}>
                        {hasPendingUploads() && (
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => {
                                    const cleared = {};
                                    IMAGE_TYPES.forEach(type => {
                                        const pendingImage = pendingImages[type.id];
                                        if (pendingImage?.previewUrl) {
                                            URL.revokeObjectURL(pendingImage.previewUrl);
                                        }
                                        cleared[type.id] = null;
                                    });
                                    setPendingImages(cleared);
                                    toast.info('All pending uploads cleared');
                                }}
                                disabled={uploading || refreshing || loading}
                            >
                                Clear All
                            </Button>
                        )}
                        
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={handleUploadAll}
                            disabled={!hasPendingUploads() || uploading || refreshing || loading || networkError}
                            startIcon={uploading ? <CircularProgress size={20} color="inherit" /> : <CloudUpload />}
                            sx={{ minWidth: 200 }}
                        >
                            {uploading 
                                ? 'Uploading...' 
                                : hasPendingUploads()
                                    ? `Upload ${pendingCount} Image(s)`
                                    : 'No Images to Upload'
                            }
                        </Button>
                    </Stack>
                </Box>
            </Paper>

            {/* Update Dialog */}
            <Dialog open={updateDialogOpen} onClose={handleCloseUpdateDialog} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Update {updatingType ? IMAGE_TYPES.find(t => t.id === updatingType)?.label : 'Image'}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, p: 2 }}>
                        {updatePreview ? (
                            <>
                                <img
                                    src={updatePreview}
                                    alt="Preview"
                                    style={{
                                        width: '100%',
                                        maxHeight: 300,
                                        objectFit: 'contain',
                                        borderRadius: 8,
                                    }}
                                />
                                <Typography variant="body2" color="text.secondary">
                                    Selected: {updateFile?.name} ({(updateFile?.size / (1024 * 1024)).toFixed(2)} MB)
                                </Typography>
                            </>
                        ) : (
                            <>
                                <PhotoCamera sx={{ fontSize: 64, color: 'grey.400' }} />
                                <Typography variant="body2" color="text.secondary">
                                    Select a new image to replace the existing one
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    Maximum file size: 3MB
                                </Typography>
                            </>
                        )}
                        
                        <Button
                            variant="outlined"
                            component="label"
                            startIcon={<CloudUpload />}
                            fullWidth
                        >
                            Select New Image
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleUpdateFileSelect}
                                ref={updateFileInputRef}
                            />
                        </Button>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUpdateDialog} disabled={loading}>
                        Cancel
                    </Button>
                    <Button 
                        onClick={handleExecuteUpdate} 
                        variant="contained" 
                        disabled={!updateFile || loading}
                    >
                        {loading ? <CircularProgress size={20} /> : 'Update Image'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Image Preview Modal */}
            <Modal 
                open={isModalOpen} 
                onClose={handleCloseModal} 
                closeAfterTransition 
                BackdropComponent={Backdrop}
                BackdropProps={{ timeout: 500 }}
            >
                <Fade in={isModalOpen}>
                    <Box sx={modalStyle}>
                        <IconButton
                            onClick={handleCloseModal}
                            sx={{ 
                                position: 'absolute', 
                                top: 8, 
                                right: 8, 
                                zIndex: 1, 
                                color: 'white', 
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            }}
                        >
                            <Close />
                        </IconButton>
                        {selectedImage && (
                            <img
                                src={selectedImage}
                                alt="Preview"
                                style={{ 
                                    width: '100%', 
                                    height: 'auto', 
                                    maxHeight: '90vh', 
                                    objectFit: 'contain',
                                    borderRadius: 4
                                }}
                            />
                        )}
                    </Box>
                </Fade>
            </Modal>
        </Box>
    );
};

export default ImageUploader;